import { IntlTFunc } from 'next-intl';

import { ProductFragment, SimpleProductFragment } from '@/fo/api/magento';

import { MappedProduct, GroupedProduct, ProductsMindbox } from '../types';

import { utilMapSimpleProductData } from './utilMapSimpleProductData';

export const utilMapGroupedProductData = (
  product: ProductFragment,
  t: IntlTFunc,
  mindboxProducts?: ProductsMindbox
): MappedProduct => {
  const productData = product as GroupedProduct;

  const {
    sku,
    mindboxId,
    link,
    specialPrice,
    basePrice,
    finalPrice,
    currency,
    labels,
    baseImage,
    thumbnail,
    mediaGallery,
    stockStatus,
    characteristics,
    brand,
    catalogBrandUrl,
    series,
    video,
    effects,

    labelsBonus,
    bonusPoints,
    bonusPointsMax,

    name,
    nameEng,
    shortDescription,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    rating,
    reviewCount,
    bestRating,
    worstRating,
    purpose,
    stockQuantity,

    description,
    activeComponents,
    composition,
    usageInstructions,

    productGroup
  } = utilMapSimpleProductData(productData, t, mindboxProducts);

  const items =
    'items' in productData && productData.items
      ? (productData.items
          .map((item) =>
            item?.product
              ? utilMapSimpleProductData(
                  item.product as SimpleProductFragment,
                  t,
                  mindboxProducts
                )
              : undefined
          )
          .filter(Boolean) as MappedProduct[])
      : [];

  return {
    sku,
    mindboxId,
    name,
    nameEng,
    brand,
    catalogBrandUrl,
    series,
    effects,
    link,
    shortDescription,
    specialPrice,
    basePrice,
    finalPrice,
    currency,
    firstLevelCategory,
    lastLevelCategory,
    breadcrumbs,
    labelsBrand,
    labelsBonus,
    labels,
    baseImage,
    thumbnail,
    mediaGallery,
    rating,
    reviewCount,
    bestRating,
    worstRating,
    stockStatus,
    stockQuantity,
    video,
    bonusPoints,
    bonusPointsMax,

    items,
    purpose,

    groupType:
      'groupType' in productData ? (productData.groupType as number) : null,

    description,
    characteristics,
    activeComponents,
    composition,
    usageInstructions,

    productGroup
  };
};
